import React, { useState, useEffect, useRef } from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { DataTable } from 'primereact/datatable';
import "./TreeTable.css";
import CreateBlankModal from "../components/modals/CreateBlankModal";
import { Add, Delete, Info } from "@mui/icons-material";
import axios from "axios";
import apiService from "../utils/api";
import downloadIcon from '../assets/download.svg';
import Snackbar from '@mui/material/Snackbar';
import DeleteConfirmationModal from "../components/modals/DeleteConfirmationModal";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import jspdfAutotable from "jspdf-autotable";
import "jspdf-autotable";
import Breadcrumbs from "../components/Breadcrumbs";
import AddDocumentModal from "../components/modals/AddDocumentModal";
import { useRBAC } from "./rbac/RbacProvider";
import { useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import Loader from "./Loader";
import Sidebar from '../components/sidebar/Sidebar';

const WIPContracts = () => {
  const { role } = useRBAC();
  const navigate = useNavigate();
  const [filters, setFilters] = useState({ global: "" });
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    node: null,
  contractId: null,
    
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [favorites, setFavorites] = useState({});
  const [nodes, setNodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editableNode, setEditableNode] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, success: false, message: "" });
  const [expandedKeys, setExpandedKeys] = useState({});
  const [isAddDocumentModalOpen, setIsAddDocumentModalOpen] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [showColumnOptions, setShowColumnOptions] = useState(false);
  const [isFavoriteLoading, setIsFavoriteLoading] = useState(false);
  const [favoriteNode, setFavoriteNode] = useState(null); 
  const [showFlatView, setShowFlatView] = useState(false);
  const [originalHierarchy, setOriginalHierarchy] = useState([]);           // ← NEW
const [currentHierarchyMode, setCurrentHierarchyMode] = useState("default"); // ← NEW
const [switchingHierarchy, setSwitchingHierarchy] = useState(false);     // ← NEW
  const mandatoryColumns = ['name','status'];
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const savedColumns = localStorage.getItem('treeTableVisibleColumns');
    const defaults = savedColumns
      ? JSON.parse(savedColumns)
      : {
          name: true,
          type: true,
          startDate: true,
          endDate: true,
          renewalDate: true,
          status: true,
          createdDate: false,
          modified: false,
          actions: true,
        };
    mandatoryColumns.forEach(col => { if (defaults.hasOwnProperty(col)) defaults[col] = true; });
    return defaults;
  });
  const downloadRef = useRef(null);
  const [tempVisibleColumns, setTempVisibleColumns] = useState(visibleColumns);

  const getUserId = () => {
    return Number(sessionStorage.getItem("user_id")) || null;
  };
const getUserRole = () => (sessionStorage.getItem("user_role") || "").replace(/\s+/g, '');
const fullAccessRoles = ['Admin', 'LegalUser', 'LegalReviewer'];
  const hasFullAccess = fullAccessRoles.includes(getUserRole());

  // Clear search when switching between views
  useEffect(() => {
    setFilters({ global: "" });
  }, [showFlatView]);

  // Flatten nodes for table view and apply search filter
  const flatRowsForTable = React.useMemo(() => {
    const displayDateLocal = (value, isEndOrRenewal = false) => {
      if (!value) return 'N/A';
      const v = String(value);
      if (isEndOrRenewal && (v === '1999-01-01' || v.startsWith('1999-01-01'))) return 'Auto renewal';
      return v;
    };
    const rows = [];
    const collect = (list) => {
      list.forEach((n) => {
        if (n?.data?.type === 'File') {
          const entityType = n.data.entity_type || (n.data.clientName?.toLowerCase().includes('vendor') ? 'vendor' : 'client');
          rows.push({
            id: n.data.id,
            name: n.data.name || '',
            type: entityType?.toLowerCase() === 'vendor' ? 'Vendor' : 'Client',
            startDate: displayDateLocal(n.data.start_date),
            endDate: displayDateLocal(n.data.end_date, true),
            renewalDate: displayDateLocal(n.data.renewal_date, true),
            status: n.data.status || '',
            createdDate: n.data.createdDate || '',
            modified: n.data.modified || ''
          });
        }
        if (n.children) collect(n.children);
      });
    };
    collect(nodes || []);
    const q = (filters.global || '').toLowerCase().trim();
    if (!q) return rows;
    return rows.filter(r => Object.values(r).join(' ').toLowerCase().includes(q));
  }, [nodes, filters.global]);

const getApiEndpoint = () => {
  const role = getUserRole();
  const userId = getUserId();

  if (role === "Admin") return "all-contracts-hierarchy?is_wip=true";
  if (role === "Client Partner" || role === "Client Partners")
    return `client-partner-contracts?partner_id=${userId}&is_wip=true`;
  return `contract-hierarchy?user_id=${userId}&is_wip=true`;
};

  // const addLevels = (nodes, level = 0) => {
  //   return nodes.map(node => {
  //     node.level = level;
  //     if (node.children && node.children.length > 0) {
  //       node.children = addLevels(node.children, level + 1);
  //     }
  //     return node;
  //   });
  // };
const addLevels = (nodes, level = 0) => {
  return nodes
    .filter(node => node.data.type === "File" ? !node.data.is_deleted : true)
    .map(node => ({
      ...node,
      level,
      children: node.children ? addLevels(node.children, level + 1) : [],
    }))
    .filter(node => node.data.type === "File" || node.children.length > 0);
};
  const filterFavorites = (nodes) => {
  if (!window.location.pathname.includes('/favourites')) return nodes;

  const filterNodes = (nodes) => {
    return nodes
      .filter(node => node.data.type === "File" ? node.data.is_favourite : true)
      .map(node => ({
        ...node,
        children: node.children ? filterNodes(node.children) : [],
      }))
      .filter(node => node.data.type === "File" || node.children.length > 0);
  };

  return filterNodes(nodes);
};

// const fetchData = async () => {
//   try {
//     const endpoint = getApiEndpoint();
//     const res = await axios.get(endpoint);
//     if (res.data && res.data.contract_hierarchy) {
//       const withLevels = addLevels(res.data.contract_hierarchy);
//       const filteredNodes = filterFavorites(withLevels);
//       setNodes(filteredNodes);
//     }
//   } catch (error) {
//     console.error("Error fetching contract hierarchy:", error);
//     setSnackbar({
//       open: true,
//       success: false,
//       message: "Error fetching contract data",
//     });
//   } finally {
//     setLoading(false);
//   }
// };
const fetchData = async () => {
  try {
    setLoading(true);
    const endpoint = getApiEndpoint();
    const res = await apiService.fetchData(endpoint);

    // Handle both contract_hierarchy and data key structures
    if (res && (res.contract_hierarchy || res.data)) {
      const hierarchy = res.contract_hierarchy || res.data;
      setOriginalHierarchy(hierarchy);  
      const withLevels = addLevels(hierarchy);

      const filteredDeleted = (nodes) =>
        nodes
          .filter((node) => (node.data.type === "File" ? !node.data.is_deleted : true))
          .map((node) => ({
            ...node,
            children: node.children ? filteredDeleted(node.children) : [],
          }))
          .filter((node) => node.data.type === "File" || node.children.length > 0);

      const filteredNodes = filterFavorites(filteredDeleted(withLevels));
      setNodes(filteredNodes);
    } else {
      throw new Error("Invalid contract hierarchy response");
    }
  } catch (error) {
    console.error("Error fetching contract hierarchy:", error);
    setSnackbar({
      open: true,
      success: false,
      message: "Error fetching contract data",
    });
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    
    fetchData();
  }, [role]);

  useEffect(() => {
    localStorage.setItem('treeTableVisibleColumns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

 const handleAddFavourite = async (node) => {
  const contractId = node.data.id;
  const userId = getUserId();
  const newIsFavourite = !node.data.is_favourite;

  let rawContractId = contractId;
  if (rawContractId && rawContractId.includes("CONTRACT-")) {
    rawContractId = rawContractId.replace("CONTRACT-", "");
  } else {
    setSnackbar({ open: true, success: false, message: "Invalid contract ID format" });
    return;
  }

  const payload = {
    user_id: userId,
    contract_id: rawContractId,
  };

  setIsFavoriteLoading(true);
  setFavoriteNode(node); // Set the node being toggled
  try {
    const response = await apiService.postData(
      `favourites?is_favourite=${newIsFavourite}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === "error" || !response.status) {
      setSnackbar({ open: true, success: false, message: response.message || "Failed to update favourite" });
    } else {
      node.data.is_favourite = newIsFavourite;
      setFavorites((prev) => ({
        ...prev,
        [node.key]: newIsFavourite,
      }));
      if (window.location.pathname.includes('/favourites') && !newIsFavourite) {
        setLoading(true);
        await fetchData();
      } else {
        setNodes([...nodes]);
      }
      setSnackbar({
        open: true,
        success: true,
        message: newIsFavourite
          ? "Contract added to favorites"
          : "Contract removed from favorites",
      });
    }
  } catch (error) {
    console.error("Error posting to favorites:", error);
    setSnackbar({ open: true, success: false, message: "Error updating favorite" });
  } finally {
    setIsFavoriteLoading(false);
    setFavoriteNode(null); // Clear the node after the action
  }
};


const swapYearAndClient = (yearFirstNodes) => {
  const clientMap = new Map();

  yearFirstNodes.forEach((yearNode) => {
    const yearKey = yearNode.key;
    const yearName = yearNode.data.year || yearNode.data.name || "Unknown Year";

    (yearNode.children || []).forEach((clientNode) => {
      // Use the original client name as displayed
      const clientName = clientNode.data.clientName || clientNode.data.name || "Unknown Client";

      // Create a unique, safe key using the full client name (preserve case and spaces)
      const safeClientKey = `client-${clientName.replace(/[^a-zA-Z0-9]/g, '_')}-${Date.now()}-${Math.random()}`;

      // If this client doesn't exist yet, create it
      if (!clientMap.has(clientName)) {
        clientMap.set(clientName, {
          key: safeClientKey,
          data: {
            type: "Folder",
            name: clientName,
            clientName: clientName,
          },
          children: [],
        });
      }

      // Add the year under this client
      const clientEntry = clientMap.get(clientName);
      clientEntry.children.push({
        key: `${safeClientKey}-year-${yearKey}`,
        data: {
          type: "Folder",
          name: yearName,
        },
        children: clientNode.children || [],
      });
    });
  });

  // Return all clients in the order they were first encountered
  return Array.from(clientMap.values());
};

const handleSwitchHierarchy = () => {
  if (!originalHierarchy || originalHierarchy.length === 0) return;

  setSwitchingHierarchy(true);

  try {
    let processed;

    if (currentHierarchyMode === "default") {
      processed = swapYearAndClient(originalHierarchy);
      setCurrentHierarchyMode("client-first");
    } else {
      processed = originalHierarchy;
      setCurrentHierarchyMode("default");
    }

    const withLevels = addLevels(processed);
    const filteredDeleted = (nodes) => nodes
      .filter(n => n.data.type === "File" ? !n.data.is_deleted : true)
      .map(n => ({ ...n, children: n.children ? filteredDeleted(n.children) : [] }))
      .filter(n => n.data.type === "File" || n.children.length > 0);

    setNodes(filterFavorites(filteredDeleted(withLevels)));
  } finally {
    setSwitchingHierarchy(false);
  }
};

const exportToExcel = () => {
  const toYMD = (v) => {
    if (!v || v === 'N/A') return v || "";
    try {
      const d = new Date(v);
      if (!isNaN(d.getTime())) return d.toISOString().slice(0,10);
    } catch(_) {}
    return String(v).slice(0,10);
  };
  const formatEndRenewal = (v) => {
    if (!v || v === 'N/A') return v || '';
    const s = String(v);
    if (s.startsWith('1999-01-01') || s.startsWith('Auto renewal')) return 'Auto renewal';
    return toYMD(s);
  };

  const computeType = (d) => {
    const entityType = d.entity_type || (d.clientName?.toLowerCase().includes('vendor') ? 'vendor' : 'client');
    return entityType?.toLowerCase() === 'vendor' ? 'Vendor' : 'Client';
  };

  const getExportValue = (data, key) => {
    switch (key) {
      case 'name': return data.name || '';
      case 'type': return computeType(data);
      case 'startDate': return toYMD(data.start_date);
      case 'endDate': return formatEndRenewal(data.end_date);
      case 'renewalDate': return formatEndRenewal(data.renewal_date);
      case 'createdDate': return data.createdDate || '';
      case 'status': return data.status || '';
      case 'modified': return data.modified || '';
      default: return '';
    }
  };

  // Define columns based on visibility
  const allColumns = [
    { key: "name", label: "Contract Name" },
    { key: "type", label: "Type" },
    { key: "startDate", label: "Start Date" },
    { key: "endDate", label: "End Date" },
    { key: "renewalDate", label: "Renewal Date" },
    { key: "createdDate", label: "Created" },
    { key: "status", label: "Status" },
    { key: "modified", label: "Modified" },
  ];
  const visibleExportCols = allColumns.filter(col => visibleColumns[col.key]);

  const buildRow = (data) => {
    const row = {};
    visibleExportCols.forEach(col => {
      row[col.label] = getExportValue(data, col.key);
    });
    return row;
  };

  const walk = (list, out = []) => {
    list.forEach((node) => {
      const nodeData = node?.data;
      if (nodeData?.type === 'File') {
        out.push(buildRow(nodeData));
      }
      if (node.children) {
        walk(node.children, out);
      }
    });
    return out;
  };

  const rows = walk(nodes, []);
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Contracts");
  XLSX.writeFile(workbook, "contracts.xlsx");
  setShowDownloadMenu(false);
};

const exportToPDF = () => {
  const doc = new jsPDF();
  const toYMD = (v) => {
    if (!v || v === 'N/A') return v || "";
    try {
      const d = new Date(v);
      if (!isNaN(d.getTime())) return d.toISOString().slice(0,10);
    } catch(_) {}
    return String(v).slice(0,10);
  };
  const formatEndRenewal = (v) => {
    if (!v || v === 'N/A') return v || '';
    const s = String(v);
    if (s.startsWith('1999-01-01') || s.startsWith('Auto renewal')) return 'Auto renewal';
    return toYMD(s);
  };
  const computeType = (d) => {
    const entityType = d.entity_type || (d.clientName?.toLowerCase().includes('vendor') ? 'vendor' : 'client');
    return entityType?.toLowerCase() === 'vendor' ? 'Vendor' : 'Client';
  };

  const allColumns = [
    { key: "name", label: "Contract Name" },
    { key: "type", label: "Type" },
    { key: "startDate", label: "Start Date" },
    { key: "endDate", label: "End Date" },
    { key: "renewalDate", label: "Renewal Date" },
    { key: "createdDate", label: "Created" },
    { key: "status", label: "Status" },
    { key: "modified", label: "Modified" },
  ];
  const visibleExportCols = allColumns.filter(col => visibleColumns[col.key]);

  const getExportValue = (data, key) => {
    switch (key) {
      case 'name': return data.name || '';
      case 'type': return computeType(data);
      case 'startDate': return toYMD(data.start_date);
      case 'endDate': return formatEndRenewal(data.end_date);
      case 'renewalDate': return formatEndRenewal(data.renewal_date);
      case 'createdDate': return data.createdDate || '';
      case 'status': return data.status || '';
      case 'modified': return data.modified || '';
      default: return '';
    }
  };

  const buildRow = (data) => visibleExportCols.map(col => getExportValue(data, col.key));

  const walk = (list, out = []) => {
    list.forEach((node) => {
      const nodeData = node?.data;
      if (nodeData?.type === 'File') {
        out.push(buildRow(nodeData));
      }
      if (node.children) {
        walk(node.children, out);
      }
    });
    return out;
  };

  const rows = walk(nodes, []);
  jspdfAutotable(doc, {
    head: [visibleExportCols.map(col => col.label)],
    body: rows,
  });
  doc.save("contracts.pdf");
  setShowDownloadMenu(false);
};


const handleTrash = async (node, reason) => {
  setIsDeleting(true);
  try {
    let rawContractId = getCleanContractId(node.data.id);
    const payload = {
      user_id: getUserId(),
      contract_id: rawContractId,
      reason: reason,
    };

    const response = await apiService.postData("enhanced-trash", payload);

    if (response?.status === "success") {
      // Refetch tree data to ensure UI reflects server state
      setLoading(true);
      const endpoint = getApiEndpoint();
      const res = await apiService.fetchData(endpoint);

     if (res && (res.contract_hierarchy || res.data)) {
  const hierarchy = res.contract_hierarchy || res.data;
  const withLevels = addLevels(hierarchy);
  setNodes(withLevels);
}

      setSnackbar({
        open: true,
        success: true,
        message: `Contract (ID: ${rawContractId}) moved to archive`,
      });
    } else {
      setSnackbar({
        open: true,
        success: false,
        message: response?.message || "Failed to move to archive",
      });
    }
  } catch (error) {
    console.error("Error moving to archive:", error);
    setSnackbar({
      open: true,
      success: false,
      message: "Error moving to archive",
    });
  } finally {
    setIsDeleting(false);
    setIsDeleteModalOpen(false);
    setLoading(false);
  }
};


  const removeNodeByKey = (nodes, keyToRemove) => {
    const keyParts = keyToRemove.split("-");
    if (keyParts.length === 1) {
      return nodes.filter((node) => node.key !== keyToRemove);
    }
    const newNodes = JSON.parse(JSON.stringify(nodes));
    let currentLevel = newNodes;
    for (let i = 0; i < keyParts.length - 1; i++) {
      const key = keyParts.slice(0, i + 1).join("-");
      const node = currentLevel.find((n) => n.key === key);
      if (!node || !node.children) return newNodes;
      currentLevel = node.children;
    }
    currentLevel.splice(
      currentLevel.findIndex((n) => n.key === keyToRemove),
      1
    );
    return newNodes;
  };

  const globalFilterFunction = (node, filter) => {
    if (!filter) return true;
    const searchLower = filter.toLowerCase();
    return (
      (node.data.name && node.data.name.toLowerCase().includes(searchLower)) ||
      (node.data.clientName && node.data.clientName.toLowerCase().includes(searchLower)) ||
      (node.data.createdDate && node.data.createdDate.toLowerCase().includes(searchLower)) ||
      (node.data.status && node.data.status.toLowerCase().includes(searchLower)) ||
      (node.data.modified && node.data.modified.toLowerCase().includes(searchLower))
    );
  };

  const toggleColumn = (key) => {
    if (mandatoryColumns.includes(key)) return;
    setTempVisibleColumns(prev => ({ ...prev, [key]: !prev[key] }));
  };

const getCleanContractId = (id) => {
  // Unicode-safe regex to prevent potential backtracking issues
  const match = String(id).match(/\d{1,20}$/u);
  return match ? match[0] : id;
};

  const getClientKey = (nodeKey) => {
    const parts = nodeKey.split("-");
    return parts[0] + "-" + parts[1];
  };

  const extractYearFromNode = (node) => {
    try {
      if (node?.key?.startsWith("YEAR-")) {
        return node.key.split("-")[1];
      }
      if (node?.key) {
        const match = node.key.match(/(19\d{2}|20\d{2})/);
        if (match) return match[1];
      }
      const cd = node?.data?.createdDate;
      if (cd && typeof cd === 'string' && cd.length >= 4) return cd.slice(0,4);
    } catch(e) {}
    return '';
  };

  const displayDate = (value, isEndOrRenewal = false) => {
    if (!value) return 'N/A';
    const v = String(value);
    if (isEndOrRenewal && (v === '1999-01-01' || v.startsWith('1999-01-01'))) return 'Auto renewal';
    return v;
  };

    return (
      <div className="departments-page-container">   {/* Sidebar container */}
        <Sidebar />
        <div className="departments-page-content">
          <Breadcrumbs />
          {/* <h3 className="title">WIP Contracts</h3> */}
          <div style={{ 
        background: '#fff', 
        borderRadius: '8px', 
        padding: '24px 28px', 
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)', 
        borderLeft: '4px solid #ff6b35', 
        marginBottom: '24px' 
      }}>
        <h1 style={{ 
          fontSize: '24px', 
          fontWeight: 700, 
          color: '#212529', 
          margin: 0, 
          display: 'flex', 
          alignItems: 'center', 
          gap: '12px' 
        }}>
          <span style={{ 
            width: '28px', 
            height: '28px', 
            background: 'linear-gradient(135deg, #ff6b35 0%, #ff8c61 100%)', 
            borderRadius: '6px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            color: '#fff', 
            fontSize: '16px' 
          }}>
            📋
          </span>
          WIP Contracts
        </h1>
      </div>
          
        <Loader
          isLoading={isFavoriteLoading}
          message={favoriteNode?.data.is_favourite ? "Removing from Favorites" : "Adding to Favorites"}
        />
        <Loader 
          isLoading={loading} 
          message="Assembling🙂 half‑baked contracts with extra care"
        />

        {!loading && (
          <>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginBottom: "20px", gap: "10px" }}>
              {["Admin", "LegalReviewer", "LegalUser"].includes(getUserRole()) && (
                <button
                  onClick={() => {
                    setModalType("document");
                    setIsAddDocumentModalOpen(true);
                    setContextMenu({ visible: false, node: null, contractId: null });
                  }}
                  style={{
                    background: "#ff6b35",
                    color: "white",
                    border: "1px solid #ff6b35",
                    padding: "8px 14px",
                    borderRadius: "6px",
                    fontSize: "0.9rem",
                    cursor: "pointer",
                    boxShadow: "var(--shadow)",
                    fontWeight:"bold",
                  }}
                  title="click to add a new contract"
                >
                  + New
                </button>
              )}
              <button
                className="add-role-button"
                onClick={() => setShowFlatView(!showFlatView)}
                style={{ background: "#ff6b35", color: "white", border: "1px solid #ff6b35", padding: "8px 14px", borderRadius: "6px", fontWeight: "bold" }}
                title="For Full View click on the contract name"
              >
                {showFlatView ? 'Tree View' : 'Table View'}
              </button>
              <button
  onClick={handleSwitchHierarchy}
  disabled={switchingHierarchy}
  style={{
    background: switchingHierarchy ? "#ccc" : "#ff6b35",
    color: "white",
    padding: "8px 14px",
    borderRadius: "6px",
    fontWeight: "bold",
    marginLeft: "10px",
    cursor: switchingHierarchy ? "not-allowed" : "pointer",
    border:'none',
  }}
>
  {switchingHierarchy ? "Switching..." : "Switch → " + (currentHierarchyMode === "default" ? "Client First" : "Year First")}
</button>
              <input
                type="text"
                placeholder="Search..."
                value={filters.global || ""}
                onChange={(e) => setFilters({ global: e.target.value })}
                style={{
                  padding: "8px",
                  width: "170px",
                  border: "1px solid #ff6b35",
                  borderRadius: "4px",
                }}
                title="Search contracts by name, client or status"
              />
              <button
                onClick={() => setShowColumnOptions(true)}
                style={{
                  cursor: "pointer",
                  padding: "4px 12px",
                  borderRadius: "6px",
                  background: "transparent",
                  color: "#4A4A4A",
                  border: "1px solid #ff6b35",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
                title="Click to show/hide columns"
              >
                ⚙ Column options
              </button>
              <div style={{ position: "relative" }} ref={downloadRef}>
              <button
                  onClick={() => setShowDownloadMenu(!showDownloadMenu)}
                  style={{
                    cursor: "pointer",
                    padding: "4px 12px",
                    borderRadius: "6px",
                    background: "transparent",
                    border: "1px solid #ff6b35",
                    color: "#4A4A4A",
                    fontSize: "16px",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                title="Click to export contracts as pdf or csv"
                >
                  <img src={downloadIcon} alt="Download" style={{ width: "16px", height: "20px" }} /> Download
                </button>
                {showDownloadMenu && (
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      marginTop: "6px",
                      borderRadius: "6px",
                      background: "white",
                      border: "1px solid #e5e7eb",
                      zIndex: 10,
                    }}
                  >
                    <button
                      onClick={exportToExcel}
                      style={{
                        cursor: "pointer",
                        border: "none",
                        display: "block",
                        padding: "8px 12px",
                        width: "120px",
                        textAlign: "left",
                        background: "none",
                        color: "#4A4A4A",
                      }}
                    >
                      Download CSV
                    </button>
                    <button
                      onClick={exportToPDF}
                      style={{
                        cursor: "pointer",
                        border: "none",
                        display: "block",
                        padding: "8px 12px",
                        width: "120px",
                        textAlign: "left",
                        background: "none",
                        color: "#4A4A4A",
                      }}
                    >
                      Download PDF
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div style={{ overflow: "hidden" }}>
              {showFlatView ? (
                <DataTable value={flatRowsForTable} paginator rows={10} rowsPerPageOptions={[5,10,20,50]} paginatorPosition="bottom" tableStyle={{ width: '100%' }}>
                  {visibleColumns.name && (
                    <Column field="name" header="Contract Name" body={(rowData) => (
                      <span style={{ cursor: "pointer", color: "#ff6b35" }} title="Click to open the document" onClick={() => { const cleanId = (rowData.id || '').toString().replace('CONTRACT-',''); navigate('/categories', { state: { contractId: cleanId, clientKey: '', fromDataTable: true, fromWipPage: true } }); }}>{rowData.name}</span>
                    )} />
                  )}
                  {visibleColumns.type && (<Column field="type" header={<span title="Type">Type</span>} />)}
                  {visibleColumns.startDate && (<Column field="startDate" header={<span title="Start date of contract">Start Date</span>} />)}
                  {visibleColumns.endDate && (<Column field="endDate" header={<span style={{ color:'#ff6b35' }} title="End date of contract">End Date</span>} />)}
                  {visibleColumns.renewalDate && (<Column field="renewalDate" header={<span style={{ color:'#ff6b35' }} title="Renewal date of contract">Renewal Date</span>} />)}
                  {visibleColumns.status && (<Column field="status" header={<span title="Status">Status</span>} />)}
                  {visibleColumns.createdDate && (<Column field="createdDate" header={<span title="Created">Created</span>} />)}
                  {visibleColumns.modified && (<Column field="modified" header={<span title="Modified">Modified</span>} />)}
                </DataTable>
              ) : (
              <TreeTable
                value={nodes}
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 20, 50]}
                expandedKeys={expandedKeys}
                onToggle={(e) => setExpandedKeys(e.value)}
                showGridlines
                globalFilter={filters.global}
                filterFunction={(node, filter) => globalFilterFunction(node, filter)}
                tableStyle={{ width: "100%", tableLayout: "fixed" }}
                rowClassName={(node) => {
                  if (
                    node.data.type === "Folder" &&
                    node.data.name.includes("Master_Agreements")
                  ) {
                    return "highlight-row";
                  }
                  return "";
                }}
              >
                {visibleColumns.name && (
                  <Column
                    field="name"
                    header="Contracts"
                    style={{ width: "25%", color: "black" }}
                    body={(node) => {
                      const isFolder = node.data?.type === "Folder";
                      const isExpanded = !!expandedKeys[node.key];
                      return (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            paddingLeft: `${node.level * 30}px`,
                            color: "black",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {node.children && (
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                setExpandedKeys((prev) => {
                                  const newKeys = { ...prev };
                                  if (newKeys[node.key]) {
                                    delete newKeys[node.key];
                                  } else {
                                    newKeys[node.key] = true;
                                  }
                                  return newKeys;
                                });
                              }}
                              style={{
                                display: "inline-flex",
                                width: "18px",
                                height: "18px",
                                background: "white",
                                color: "#ff6b35",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                lineHeight: "18px",
                                verticalAlign: "middle",
                                fontSize: "18px",
                                marginLeft:"5px"
                              }}
                              title="Click to expand/collapse"
                            >
                              {isExpanded ? "−" : "+"}
                            </span>
                          )}
                          {isFolder ? (
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis" }} title={node.key?.startsWith('YEAR-') ? `You can see the ${node.data.name} year contracts under me` : node.data.name}>
                              📂 {node.data.name}
                            </span>
                          ) : (
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                              📄{" "}
                              <a
                                href={node.data.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#1976d2", textDecoration: "none" }}
                                title="Click to open the document"
                              >
                                {node.data.name}
                              </a>
                            </span>
                          )}
                        </div>
                      );
                    }}
                  />
                )}
                {visibleColumns.type && (
                  <Column
                    field="type"
                    header="Type"
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    body={(node) => {
                      const isYear = node.key?.startsWith('YEAR-');
                      const isContractNode = node.data?.type === 'File';
                      const isContractTypeFolder = node.data?.type === 'Folder' && (node.data?.contractType || node.data?.contract_type_name);
                      if (isYear || isContractNode || isContractTypeFolder) {
                        return null;
                      }
                      const entityType = node.data.entity_type || (node.data.clientName?.toLowerCase().includes('vendor') ? 'vendor' : 'client');
                      const typeLabel = entityType?.toLowerCase() === 'vendor' ? 'Vendor' : 'Client';
                      return (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {typeLabel}
                        </span>
                      );
                    }}
                  />
                )}
                {visibleColumns.createdDate && (
                  <Column
                    field="createdDate"
                    header={<span title="Created">Created</span>}
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    sortable
                    body={(node) => {
                      if (node.key.split("-").length === 1) return null;
                      return (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {node.data.createdDate}
                        </span>
                      );
                    }}
                  />
                )}
                {visibleColumns.startDate && (
                  <Column
                    field="startDate"
                    header={<span title="Start Date">Start Date</span>}
                    style={{ width: "12%", textAlign: "center", color: "black" }}
                    body={(node) => (
                      node.data.type === "File" ? (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {displayDate(node.data.start_date)}
                        </span>
                      ) : null
                    )}
                  />
                )}
                {visibleColumns.endDate && (
                  <Column
                    field="endDate"
                    header={<span style={{ color:'#ff6b35' }}>End Date</span>}
                    style={{ width: "12%", textAlign: "center", color: "black" }}
                    body={(node) => (
                      node.data.type === "File" ? (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {displayDate(node.data.end_date, true)}
                        </span>
                      ) : null
                    )}
                  />
                )}
                {visibleColumns.renewalDate && (
                  <Column
                    field="renewalDate"
                    header={<span style={{ color:'#ff6b35' }}>Renewal Date</span>}
                    style={{ width: "14%", textAlign: "center", color: "black" }}
                    body={(node) => (
                      node.data.type === "File" ? (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {displayDate(node.data.renewal_date, true)}
                        </span>
                      ) : null
                    )}
                  />
                )}
                {visibleColumns.status && (
                  <Column
                    field="status"
                    header={<span title="Status">Status</span>}
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    body={(node) => {
                      if (node.key.split("-").length === 1 || node.data.type === "Folder") return null;
                      const status = node.data.status || "Trashed";
                      const statusColorMap = {
                        "Active": "#FF9800",
                        "Approved": "#4CAF50",
                        "Archived": "#9C27B0",
                        "Draft": "#2196F3",
                        "Expired": "#F44336",
                        "Pending Approval": "#FFEB3B",
                        "Signed": "#009688",
                        "Terminated": "#616161",
                        "Trashed": "#FF6F3C",
                        "Moved to Trash": "#FF6F3C",
                      };
                      const backgroundStyle = {
                        background: statusColorMap[status] || "#616161",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        color: status === "Pending Approval" ? "#333" : "#fff",
                        display: "inline-block",
                        textAlign: "center",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      };
                      return <span style={backgroundStyle}>{status}</span>;
                    }}
                  />
                )}
                {visibleColumns.modified && (
                  <Column
                    field="modified"
                    header={<span title="Modified">Modified</span>}
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    sortable
                    body={(node) => {
                      if (node.key.split("-").length === 1) return null;
                      return (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {node.data.modified}
                        </span>
                      );
                    }}
                  />
                )}
                {visibleColumns.actions && (
                  <Column
                    header={<span title="Actions">Actions</span>}
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    body={(node) => {
                      const isFile = node.data?.type === "File";
                      const isNonFirstLevelFolder = node.data?.type === "Folder" && node.key.split("-").length > 1;
                      if (!isFile && !isNonFirstLevelFolder) return null;
                      return (
                        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                          {isFile && (
                            <>
                              <Info
                                style={{ cursor: "pointer", color: "#ff6b35", width: "16px", height: "16px" }}
                                titleAccess="View Details"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  const cleanId = getCleanContractId(node.data.id);
                                  const clientKey = getClientKey(node.key);
                                  navigate("/categories", { state: { contractId: cleanId, clientKey, fromTreeTable: true, fromWipPage: true } });
                                }}
                              />
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill={node.data.is_favourite ? "#ff6b35" : "none"}
                                stroke="#ff6b35"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="action-image1"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleAddFavourite(node);
                                }}
                                titleAccess="click to add to favourites"
                              >
                                <polygon points="12 2 15 9 22 9 17 14 18 21 12 17 6 21 7 14 2 9 9 9 12 2" />
                              </svg>
                              {hasFullAccess && (
                                <Delete
                                  style={{ cursor: node.data.is_deleted ? "not-allowed" : "pointer", width: "16px", height: "16px", color: "#ff6b35", fill: node.data.is_deleted ? "#ff6b35" : "" }}
                                  titleAccess={node.data.is_deleted ? "Already Deleted" : "Move to Archive"}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (!node.data.is_deleted) { setContractToDelete(node); setIsDeleteModalOpen(true); }
                                  }}
                                />
                              )}
                            </>
                          )}
                          {isNonFirstLevelFolder && hasFullAccess && (
                            <Add
                              style={{ cursor: "pointer", color: "#ff6b35", width: "16px", height: "16px", display: "inline-flex", visibility: "visible", opacity: 1, fill: "#ff6b35", pointerEvents: "auto", zIndex: 1 }}
                              titleAccess="Add New Document"
                              onClick={(e) => { e.preventDefault(); e.stopPropagation(); setModalType("document"); setIsAddDocumentModalOpen(true); setContextMenu({ visible: false, node, contractId: null }); }}
                            />
                          )}
                        </div>
                      );
                    }}
                  />
                )}
              </TreeTable>
              )}
            </div>

            {showColumnOptions && (
                        <div
                          style={{
                            position: "fixed",
                            inset: 0,
                            background: "rgba(0,0,0,0.4)",
                            backdropFilter: "blur(6px)",
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "flex-end",
                            zIndex: 1000,
                          }}
                        >
                          <div
                            style={{
                              width: "340px",
                              background: "#fff",
                              borderRadius: "8px",
                              overflow: "hidden",
                              marginTop: "100px",
                              marginRight: "20px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px 12px",
                                fontWeight: "700",
                                background: "#ff6b35",
                                color: "#fff",
                              }}
                            >
                              <div>Column Options</div>
                              <button
                                onClick={() => setShowColumnOptions(false)}
                                aria-label="Close"
                                style={{ background: "transparent", border: "none", fontSize: "25px", cursor: "pointer", color: "#fff" }}
                              >
                                ×
                              </button>
                            </div>
                            <div style={{ maxHeight: "50vh", overflowY: "auto", padding: "10px 12px" }}>
                              {["name", "type", "startDate", "endDate", "renewalDate", "status", "createdDate", "modified", "actions"].map(
                                (key) => (
                                  <div
                                    key={key}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "8px 0",
                                      borderBottom: "1px solid #f3f4f6",
                                    }}
                                  >
                                    <span style={{ fontSize: "14px", color: "#111827" }}>
                                      {key === "name" ? "Contract Name" : key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, " $1")}
                                      {mandatoryColumns.includes(key) ? <span style={{ color: '#ff6b35' }}> *</span> : ''}
                                    </span>
                                    <button
                                      onClick={() => toggleColumn(key)}
                                      disabled={mandatoryColumns.includes(key)}
                                      aria-label={tempVisibleColumns[key] ? `Hide ${key}` : `Show ${key}`}
                                      style={{ background: "transparent", border: "none", cursor: mandatoryColumns.includes(key) ? 'not-allowed' : 'pointer', opacity: mandatoryColumns.includes(key) ? 0.6 : 1 }}
                                    >
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                        <circle cx="12" cy="12" r="3" />
                                        {!tempVisibleColumns[key] && (
                                          <line x1="2" y1="2" x2="18" y2="18" stroke="#000000" strokeWidth="3" />
                                        )}
                                      </svg>
                                    </button>
                                  </div>
                                )
                              )}
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", padding: "10px 12px", borderTop: "1px solid #e5e7eb" }}>
                              <button
                                onClick={() => { setTempVisibleColumns(visibleColumns); setShowColumnOptions(false); }}
                                style={{ background: "transparent", color: "#ff6b35", border: "1px solid #ff6b35", padding: "8px 14px", borderRadius: "6px" }}
                              >
                                Cancel
                              </button>
                              <button
                                onClick={() => { const newVisible = { ...tempVisibleColumns }; mandatoryColumns.forEach(col => { if (newVisible.hasOwnProperty(col)) newVisible[col] = true; }); setVisibleColumns(newVisible); localStorage.setItem('treeTableVisibleColumns', JSON.stringify(newVisible)); setShowColumnOptions(false); }}
                                style={{ background: "#ff6b35", color: "#fff", border: "1px solid #ff6b35", padding: "8px 14px", borderRadius: "6px" }}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      
                      <CreateBlankModal
                        isOpen={isModalOpen}
                        onClose={() => {
                          setIsModalOpen(false);
                          setContextMenu({ visible: false, node: null, contractId: null });
                        }}
                        onSave={async (data, saveCompleted) => {
                          console.log(
                            "Save initiated",
                            modalType,
                            "under folder:",
                            contextMenu.node?.data?.name,
                            "data:",
                            data
                          );
                          setIsModalOpen(false);
                          setLoading(true);
                          try {
                            if (saveCompleted && typeof saveCompleted === "function") {
                              await new Promise((resolve) => saveCompleted(resolve));
                            }
                            const endpoint = getApiEndpoint();
                            const res = await axios.get(endpoint);
                            if (res.data && res.data.contract_hierarchy) {
                              const withLevels = addLevels(res.data.contract_hierarchy);
                              setNodes(withLevels);
                            }
                          } catch (error) {
                            console.error("Error refreshing contract hierarchy after save:", error);
                            setSnackbar({
                              open: true,
                              success: false,
                              message: "Error refreshing data after save",
                            });
                          } finally {
                            setLoading(false);
                          }
                        }}
                        parentNode={contextMenu.node}
                      />
                      
                      <AddDocumentModal
                        isOpen={isAddDocumentModalOpen}
                        onClose={() => {
                          setIsAddDocumentModalOpen(false);
                          setContextMenu({ visible: false, node: null, contractId: null });
                        }}
                        onSelectTemplate={() => {
                          console.log("Template selection triggered");
                        }}
                        onSave={async (data, saveCompleted) => {
                          console.log("Save initiated from AddDocumentModal", modalType, "data:", data);
                          setIsAddDocumentModalOpen(false);
                          setLoading(true);
                          try {
                            if (saveCompleted && typeof saveCompleted === "function") {
                              await new Promise((resolve) => saveCompleted(resolve));
                            }
                            const endpoint = getApiEndpoint();
                            const res = await axios.get(endpoint);
                            if (res.data && res.data.contract_hierarchy) {
                              const withLevels = addLevels(res.data.contract_hierarchy);
                              setNodes(withLevels);
                            }
                          } catch (error) {
                            console.error("Error refreshing contract hierarchy after save:", error);
                            setSnackbar({
                              open: true,
                              success: false,
                              message: "Error refreshing data after save",
                            });
                          } finally {
                            setLoading(false);
                          }
                        }}
                        parentNode={contextMenu.node}
                      />
                      <DeleteConfirmationModal
              isOpen={isDeleteModalOpen}
              onClose={() => setIsDeleteModalOpen(false)}
              onConfirm={(reason) => {
                if (contractToDelete) handleTrash(contractToDelete, reason);
              }}
              contractName={contractToDelete?.data?.name}
              isDeleting={isDeleting}
            />
            
                      <Snackbar
                        open={snackbar.open}
                        autoHideDuration={5000}
                        onClose={() => setSnackbar({ ...snackbar, open: false })}
                        message={snackbar.message}
                        sx={{
                          "& .MuiSnackbarContent-root": {
                            backgroundColor: snackbar.success ? "#4caf50" : "#f44336",
                          },
                          zIndex: 1400,
                        }}
                      />
          </>
        )}
      </div>
    </div>
  );

};

export default WIPContracts;